module.exports = __webpack_public_path__ + "../../../static/img/img_finish.0371a6ed.png";